import { Command } from 'ckeditor5';
import { ConditionState } from './State';
export class InsertConditionCommand extends Command {
    static get pluginName() {
        return 'insertCondition';
    }
    constructor(editor) {
        super(editor);
        this.state = this.editor.plugins.get(ConditionState);
    }
    refresh() {
        const { model } = this.editor;
        const { selection } = model.document;
        // Enable only when there's a non-collapsed selection
        this.isEnabled = !selection.isCollapsed;
    }
    addCondition(options) {
        const { id, type } = options;
        const { model } = this.editor;
        model.change((writer) => {
            const { selection } = model.document;
            const firstRange = selection.getFirstRange();
            if (!firstRange || firstRange.isCollapsed) {
                return;
            }
            const name = `${type}:${id}`;
            writer.addMarker(`condition-inline:${name}`, {
                usingOperation: true,
                affectsData: true,
                range: firstRange,
            });
            this.state.addCondition(name);
            writer.setSelection(firstRange.end);
        });
    }
}
